import styled from "@emotion/styled";

export const MetabotHeader = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
